import {
  type BroadcastAction,
  CHANNEL_NAME,
} from "@/shared/services/broadcast/BroadcastActions.ts";

export default function sendBroadcastAction(action: BroadcastAction): void {
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage(action);
  channel.close();
}
